function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M18.221 6.149c-1.455 0-2.64-1.159-2.64-2.583 0-1.423 1.185-2.583 2.64-2.583 1.454 0 2.638 1.16 2.638 2.583 0 1.424-1.184 2.583-2.638 2.583zm0-3.974c-.784 0-1.423.624-1.423 1.391s.639 1.391 1.423 1.391c.782 0 1.421-.624 1.421-1.391s-.639-1.391-1.421-1.391zm-6.205 10.76L8.54 10.696l-2.911 3.751-1.211-.901 3.77-4.86 3.466 2.232 2.911-3.824 1.221.89-3.77 4.951zm-9.6-6.018v7.791c0 2.095 1.741 3.799 3.881 3.799h8.986c2.141 0 3.883-1.704 3.883-3.799v-7.4h1.522v7.4c0 2.916-2.424 5.289-5.405 5.289H6.297c-2.98 0-5.404-2.373-5.404-5.289V6.917c0-2.917 2.424-5.29 5.404-5.29h7.95v1.49h-7.95c-2.14 0-3.881 1.704-3.881 3.8zm4.641 15.159h7.434c.432 0 .782.352.782.783 0 .432-.35.781-.782.781H7.057c-.433 0-.783-.349-.783-.781 0-.431.35-.783.783-.783z"
}));

var SvgPlatforms = function SvgPlatforms(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 24,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPlatforms, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/platforms.c6e72b25.svg";
export { ForwardRef as ReactComponent };